'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useMemo, useState } from 'react';
import { ArrowUp } from 'lucide-react';
import { Mode } from '@/components/shared/types';
interface GoUpButtonProps {
  mode: Mode;
}
type Variant = {
  className: string;
};
export default function GoUpButton(t0) {
  const $ = _c(17);
  const {
    mode
  } = t0;
  const [isVisible, setIsVisible] = useState(false);
  let t1;
  bb0: switch (mode) {
    case "frontend":
      {
        let t2;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
          t2 = {
            className: "bg-white/90 text-rose-600 shadow-lg shadow-rose-200/60 border border-rose-100 rounded-full backdrop-blur-md hover:-translate-y-0.5"
          };
          $[0] = t2;
        } else {
          t2 = $[0];
        }
        t1 = t2;
        break bb0;
      }
    case "backend":
      {
        let t2;
        if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
          t2 = {
            className: "bg-gradient-to-br from-emerald-500 to-teal-500 text-white shadow-xl shadow-emerald-500/40 border border-emerald-200/40 rounded-md hover:-translate-y-0.5"
          };
          $[1] = t2;
        } else {
          t2 = $[1];
        }
        t1 = t2;
        break bb0;
      }
    case "mobile":
      {
        let t2;
        if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
          t2 = {
            className: "bg-white/10 text-white shadow-lg shadow-cyan-400/40 border border-white/20 rounded-2xl backdrop-blur-lg hover:-translate-y-0.5"
          };
          $[2] = t2;
        } else {
          t2 = $[2];
        }
        t1 = t2;
        break bb0;
      }
    case "qa":
      {
        let t2;
        if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
          t2 = {
            className: "bg-gradient-to-br from-cyan-500 to-blue-500 text-white shadow-xl shadow-cyan-500/40 border border-cyan-200/60 rounded-full hover:-translate-y-0.5"
          };
          $[3] = t2;
        } else {
          t2 = $[3];
        }
        t1 = t2;
        break bb0;
      }
    case "blockchain":
      {
        let t2;
        if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
          t2 = {
            className: "bg-gradient-to-br from-emerald-400 to-lime-300 text-black shadow-xl shadow-emerald-400/50 border border-lime-200/60 rounded-lg hover:-translate-y-0.5"
          };
          $[4] = t2;
        } else {
          t2 = $[4];
        }
        t1 = t2;
        break bb0;
      }
    case "ai":
      {
        let t2;
        if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
          t2 = {
            className: "bg-gradient-to-br from-cyan-400 via-fuchsia-500 to-purple-600 text-white shadow-xl shadow-purple-500/40 border border-cyan-200/50 rounded-full hover:-translate-y-0.5"
          };
          $[5] = t2;
        } else {
          t2 = $[5];
        }
        t1 = t2;
        break bb0;
      }
    default:
      {
        let t2;
        if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
          t2 = {
            className: "bg-gradient-to-br from-indigo-500 to-slate-600 text-white shadow-xl shadow-indigo-500/40 border border-indigo-200/60 rounded-full hover:-translate-y-0.5"
          };
          $[6] = t2;
        } else {
          t2 = $[6];
        }
        t1 = t2;
      }
  }
  const variant = t1;
  let t2;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      const handleScroll = () => {
        setIsVisible(window.scrollY > 240);
      };
      handleScroll();
      window.addEventListener("scroll", handleScroll, {
        passive: true
      });
      return () => window.removeEventListener("scroll", handleScroll);
    };
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== mode) {
    t3 = [mode];
    $[8] = mode;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  useEffect(t2, t3);
  const shouldShow = mode === "frontend" ? true : isVisible;
  let t4;
  if ($[10] !== mode) {
    t4 = () => {
      if (mode === "frontend") {
        const canvas = document.querySelector(".frontend-figma-canvas");
        if (canvas instanceof HTMLElement) {
          canvas.scrollTo({
            top: 0,
            behavior: "smooth"
          });
          return;
        }
      }
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    };
    $[10] = mode;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  const handleClick = t4;
  const t5 = `sm:hidden fixed right-4 z-[12010] h-14 w-14 flex items-center justify-center transition-all duration-300 ease-out pointer-events-auto ${variant.className} ${shouldShow ? "opacity-100 translate-y-0" : "opacity-0 translate-y-3 pointer-events-none"}`;
  let t6;
  let t7;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      bottom: "calc(env(safe-area-inset-bottom, 0px) + 20px)"
    };
    t7 = <ArrowUp size={20} />;
    $[12] = t6;
    $[13] = t7;
  } else {
    t6 = $[12];
    t7 = $[13];
  }
  let t8;
  if ($[14] !== handleClick || $[15] !== t5) {
    t8 = <button type="button" onClick={handleClick} aria-label="Go to top" className={t5} style={t6}>{t7}</button>;
    $[14] = handleClick;
    $[15] = t5;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  return t8;
}